// src/pages/SettingsPage.js
import React, { useState, useEffect } from 'react';
import { schoolAPI, authAPI, yearAPI } from '../api/api';
import toast from 'react-hot-toast';
import './CommonPage.css';

export default function SettingsPage() {
  const [school,  setSchool]  = useState({});
  const [pwForm,  setPwForm]  = useState({ current_password:'', new_password:'', confirm:'' });
  const [years,   setYears]   = useState([]);
  const [yrForm,  setYrForm]  = useState({ year_label:'', start_date:'', end_date:'', is_current:true });
  const [loading, setLoading] = useState(false);
  const [tab,     setTab]     = useState('school');

  useEffect(() => {
    schoolAPI.get().then(r=>setSchool(r.data.data||{})).catch(()=>{});
    yearAPI.list().then(r=>setYears(r.data.data||[])).catch(()=>{});
  },[]);

  const saveSchool = async () => {
    setLoading(true);
    try { await schoolAPI.update(school); toast.success('ಶಾಲೆ ಮಾಹಿತಿ ಅಪ್‌ಡೇಟ್ ✅'); }
    catch(e) { toast.error(e.response?.data?.message||'ತಪ್ಪಾಗಿದೆ'); }
    finally { setLoading(false); }
  };

  const changePw = async () => {
    if (!pwForm.current_password||!pwForm.new_password) { toast.error('ಎಲ್ಲಾ ಅಂಕಣ ತುಂಬಿಸಿ'); return; }
    if (pwForm.new_password !== pwForm.confirm) { toast.error('ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ಹೊಂದಾಣಿಕೆ ಆಗುತ್ತಿಲ್ಲ'); return; }
    if (pwForm.new_password.length < 6) { toast.error('ಕನಿಷ್ಠ 6 ಅಕ್ಷರ ಬೇಕು'); return; }
    setLoading(true);
    try { await authAPI.changePassword(pwForm.current_password, pwForm.new_password); toast.success('ಪಾಸ್‌ವರ್ಡ್ ಬದಲಾಗಿದೆ ✅'); setPwForm({current_password:'',new_password:'',confirm:''}); }
    catch(e) { toast.error(e.response?.data?.message||'ತಪ್ಪಾಗಿದೆ'); }
    finally { setLoading(false); }
  };

  const saveYear = async () => {
    if (!yrForm.year_label||!yrForm.start_date||!yrForm.end_date) { toast.error('ಎಲ್ಲಾ ಅಂಕಣ ತುಂಬಿಸಿ'); return; }
    setLoading(true);
    try { await yearAPI.create(yrForm); toast.success('ಶೈಕ್ಷಣಿಕ ವರ್ಷ ಮಾಡಲಾಗಿದೆ ✅'); yearAPI.list().then(r=>setYears(r.data.data)); }
    catch(e) { toast.error(e.response?.data?.message||'ತಪ್ಪಾಗಿದೆ'); }
    finally { setLoading(false); }
  };

  const f = (k,v) => setSchool(p=>({...p,[k]:v}));

  return (
    <div className="common-page">
      <div className="page-header">
        <h1 className="page-title">🔧 ಸೆಟ್ಟಿಂಗ್ಸ್</h1>
        <p className="page-desc">ಶಾಲೆ, ವರ್ಷ ಮತ್ತು ಭದ್ರತಾ ಸೆಟ್ಟಿಂಗ್ಸ್</p>
      </div>

      <div className="rep-tabs" style={{marginBottom:'1.5rem'}}>
        {[['school','🏫 ಶಾಲೆ ಮಾಹಿತಿ'],['year','📅 ಶೈಕ್ಷಣಿಕ ವರ್ಷ'],['password','🔒 ಪಾಸ್‌ವರ್ಡ್']].map(([k,l])=>(
          <button key={k} className={`rep-tab ${tab===k?'active':''}`} onClick={()=>setTab(k)}>{l}</button>
        ))}
      </div>

      {tab === 'school' && (
        <div className="settings-card">
          <h3 className="settings-section-title">ಶಾಲೆಯ ಮಾಹಿತಿ</h3>
          <div className="settings-grid">
            {[
              {label:'ಕನ್ನಡ ಹೆಸರು', key:'name_kannada', ph:'ಸರ್ಕಾರಿ ಶಾಲೆ...'},
              {label:'English ಹೆಸರು', key:'name_english', ph:'Government School...'},
              {label:'ದೂರವಾಣಿ', key:'phone', ph:'08289-XXXXXX'},
              {label:'ಇಮೇಲ್', key:'email', ph:'school@karnataka.gov.in'},
              {label:'ಗ್ರಾಮ', key:'village', ph:'ಗ್ರಾಮ ಹೆಸರು'},
              {label:'ಕ್ಲಸ್ಟರ್', key:'Cluster', ph:'ಕ್ಲಸ್ಟರ್'},
              {label:'ತಾಲೂಕು', key:'taluk', ph:'ತಾಲೂಕು'},
              {label:'ಜಿಲ್ಲೆ', key:'district', ph:'ಜಿಲ್ಲೆ'},
            ].map(({label,key,ph})=>(
              <div key={key} className="form-row">
                <label className="form-row-label">{label}</label>
                <input className="modal-input" placeholder={ph} value={school[key]||''} onChange={e=>f(key,e.target.value)} />
              </div>
            ))}
          </div>
          <button className="modal-save-btn" style={{marginTop:'1rem',width:'100%'}} onClick={saveSchool} disabled={loading}>
            {loading?'ಉಳಿಸುತ್ತಿದೆ...':'💾 ಮಾಹಿತಿ ಉಳಿಸಿ'}
          </button>
        </div>
      )}

      {tab === 'year' && (
        <div className="settings-card">
          <h3 className="settings-section-title">ಶೈಕ್ಷಣಿಕ ವರ್ಷ</h3>
          {years.map(y=>(
            <div key={y.id} style={{display:'flex',alignItems:'center',gap:'1rem',padding:'0.7rem 0',borderBottom:'1px solid rgba(255,255,255,0.06)'}}>
              <span style={{fontFamily:'Syne',fontWeight:700,color:'#fff'}}>{y.year_label}</span>
              <span style={{fontFamily:'Noto Sans Kannada',fontSize:'0.75rem',color:'rgba(255,255,255,0.4)'}}>{y.start_date} — {y.end_date}</span>
              {y.is_current===1 && <span style={{background:'rgba(74,222,128,0.15)',color:'#86efac',fontSize:'0.68rem',padding:'0.15rem 0.6rem',borderRadius:'20px',border:'1px solid rgba(74,222,128,0.25)'}}>ಪ್ರಸ್ತುತ</span>}
            </div>
          ))}
          <div style={{marginTop:'1.2rem'}}>
            <h4 style={{fontFamily:'Noto Sans Kannada',fontSize:'0.85rem',color:'rgba(255,255,255,0.7)',marginBottom:'0.8rem'}}>ಹೊಸ ವರ್ಷ ಮಾಡಿ</h4>
            <div className="settings-grid">
              <div className="form-row">
                <label className="form-row-label">ವರ್ಷ ಲೇಬಲ್</label>
                <input className="modal-input" placeholder="2025-26" value={yrForm.year_label} onChange={e=>setYrForm(p=>({...p,year_label:e.target.value}))} />
              </div>
              <div className="form-row">
                <label className="form-row-label">ಪ್ರಾರಂಭ ದಿನಾಂಕ</label>
                <input className="modal-input" type="date" value={yrForm.start_date} onChange={e=>setYrForm(p=>({...p,start_date:e.target.value}))} />
              </div>
              <div className="form-row">
                <label className="form-row-label">ಅಂತ್ಯ ದಿನಾಂಕ</label>
                <input className="modal-input" type="date" value={yrForm.end_date} onChange={e=>setYrForm(p=>({...p,end_date:e.target.value}))} />
              </div>
              <div className="form-row" style={{flexDirection:'row',alignItems:'center',gap:'0.8rem'}}>
                <input type="checkbox" id="isCurrent" checked={yrForm.is_current} onChange={e=>setYrForm(p=>({...p,is_current:e.target.checked}))} style={{width:'18px',height:'18px',accentColor:'#16a34a'}} />
                <label htmlFor="isCurrent" className="form-row-label" style={{margin:0}}>ಪ್ರಸ್ತುತ ವರ್ಷ ಆಗಿ ಹೊಂದಿಸಿ</label>
              </div>
            </div>
            <button className="modal-save-btn" style={{marginTop:'1rem',width:'100%'}} onClick={saveYear} disabled={loading}>
              {loading?'ಮಾಡುತ್ತಿದೆ...':'+ ಶೈಕ್ಷಣಿಕ ವರ್ಷ ಮಾಡಿ'}
            </button>
          </div>
        </div>
      )}

      {tab === 'password' && (
        <div className="settings-card" style={{maxWidth:'420px'}}>
          <h3 className="settings-section-title">ಪಾಸ್‌ವರ್ಡ್ ಬದಲಿಸಿ</h3>
          {[
            {label:'ಹಳೆಯ ಪಾಸ್‌ವರ್ಡ್', key:'current_password'},
            {label:'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್', key:'new_password'},
            {label:'ಹೊಸ ಪಾಸ್‌ವರ್ಡ್ ದೃಢಪಡಿಸಿ', key:'confirm'},
          ].map(({label,key})=>(
            <div key={key} className="form-row" style={{marginBottom:'1rem'}}>
              <label className="form-row-label">{label}</label>
              <input className="modal-input" type="password" value={pwForm[key]} onChange={e=>setPwForm(p=>({...p,[key]:e.target.value}))} />
            </div>
          ))}
          <button className="modal-save-btn" style={{width:'100%'}} onClick={changePw} disabled={loading}>
            {loading?'ಬದಲಿಸುತ್ತಿದೆ...':'🔒 ಪಾಸ್‌ವರ್ಡ್ ಬದಲಿಸಿ'}
          </button>
        </div>
      )}

      <style>{`
        .settings-card{background:rgba(255,255,255,0.04);border:1px solid rgba(255,255,255,0.08);border-radius:16px;padding:1.5rem}
        .settings-section-title{font-family:'Noto Sans Kannada',sans-serif;font-size:.9rem;font-weight:700;color:#fff;margin-bottom:1.2rem}
        .settings-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(240px,1fr));gap:1rem}
        .rep-tab{padding:.6rem 1.4rem;border-radius:10px;background:rgba(255,255,255,.05);border:1px solid rgba(255,255,255,.1);color:rgba(255,255,255,.6);font-family:'Noto Sans Kannada',sans-serif;font-size:.85rem;cursor:pointer;transition:all .2s}
        .rep-tab.active{background:linear-gradient(135deg,rgba(22,163,74,.2),rgba(21,128,61,.1));border-color:rgba(74,222,128,.3);color:#86efac}
        .rep-tabs{display:flex;gap:.5rem;flex-wrap:wrap}
      `}</style>
    </div>
  );
}
